import type { HTMLAttributes, ReactNode } from 'react'
import type { AutocompleteRenderOptionState } from '@mui/material'
import { type AutocompleteOption } from '../model'
import { AutocompleteOptionRow, type AutocompleteOptionRowProps } from './AutocompleteOptionRow'
import { getOptionValue } from '../helpers'

export const autocompleteOptionRenderer = <Value = AutocompleteOption<string>, FreeSolo extends boolean = false>(
  getOptionLabel: AutocompleteOptionRowProps<Value, FreeSolo>['getOptionLabel'],
  multiple = false
) =>
  function renderer(
    props: HTMLAttributes<HTMLLIElement>,
    option: Value,
    {
      selected,
      indeterminate,
      withDivider,
    }: AutocompleteRenderOptionState & { indeterminate?: boolean; withDivider?: boolean }
  ): ReactNode {
    return (
      <AutocompleteOptionRow<Value, FreeSolo>
        withCheckbox={multiple}
        selected={selected}
        indeterminate={indeterminate}
        getOptionLabel={getOptionLabel}
        liProps={props}
        key={getOptionValue<Value>(option)}
        option={option}
        withDivider={withDivider}
        small
      />
    )
  }
